import { api } from '../../api/instance';

export const cartService = {
  addProductToCart(payload) {
    return api.post('v3/carts', payload).then((r) => r.cart);
  },
  cleanCart() {
    return api.post('v3/carts/clean', {}).then((r) => r.cart);
  },
  addCoupled() {
    return api.post('v3/carts/coupled', {}).then((r) => r.cart);
  },
  changeReturnTarePromiseCount(count) {
    return api.post('v3/carts/return_tare_promise', { count }).then((r) => r.cart);
  },
  // Способ получения тары: exchange | foreign | rent | buy.
  // Сервер сам пересобирает тарные строки корзины под режим и отдаёт её целиком.
  setTareMode(mode) {
    return api.post('v3/carts/tare_mode', { mode }).then((r) => r.cart);
  },
  repeatOrder(orderId) {
    return api.post('v3/carts/repeat', { order_id: orderId }).then((r) => r.cart);
  },
};



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/cartStore/service.js